import { render, staticRenderFns } from "./Feet.vue?vue&type=template&id=29018368&scoped=true&"
import script from "./Feet.vue?vue&type=script&lang=js&"
export * from "./Feet.vue?vue&type=script&lang=js&"
import style0 from "./Feet.vue?vue&type=style&index=0&id=29018368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29018368",
  null
  
)

export default component.exports